var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { i18n } from '@easydata/core';
import { QueryChangeAction } from '@easyquery/core';
import { domel } from '@easydata/ui';
import { DropDownRenderer } from '../dropdown_renderer';
import { eqCssPrefix } from '../../../utils/utils';
import { QPEditablePart } from '../../../types/qp_editable_part';
var AddRowRenderer = /** @class */ (function (_super) {
    __extends(AddRowRenderer, _super);
    function AddRowRenderer(panel, entitiesMenu, slot) {
        var _this = _super.call(this, slot) || this;
        _this.panel = panel;
        _this.menu = entitiesMenu;
        return _this;
    }
    Object.defineProperty(AddRowRenderer.prototype, "cssPrefix", {
        get: function () {
            return 'eqjs-qp';
        },
        enumerable: true,
        configurable: true
    });
    AddRowRenderer.prototype.getLabelText = function () {
        return i18n.getText('CmdClickToAddCondition');
    };
    AddRowRenderer.prototype.getClassesToAdd = function () {
        return eqCssPrefix + "-addrow " + this.cssPrefix + "-addrow";
    };
    AddRowRenderer.prototype.isEditable = function () {
        return _super.prototype.isEditable.call(this)
            && ((this.panel.options.editableParts & QPEditablePart.Addition) === QPEditablePart.Addition);
    };
    AddRowRenderer.prototype.renderLabelElement = function () {
        var _this = this;
        var displayedText = this.getLabelText();
        if (this.isEditable()) {
            this.labelElement = domel('a')
                .attr('href', 'javascript:void(0)')
                .title(displayedText)
                .text(displayedText)
                .on('click', function (ev) {
                ev.preventDefault();
                _this.showEditor();
                return false;
            })
                .toDOM();
        }
        else {
            this.labelElement = domel('div')
                .toDOM();
        }
        return this.labelElement;
    };
    AddRowRenderer.prototype.renderEditor = function () {
        // do nothing - the menu is alredy created
    };
    AddRowRenderer.prototype.itemSelected = function (id) {
        var query = this.panel.getQuery();
        var descr = {
            parent: query.getRootCondition(),
            attributeId: id
        };
        var cond = query.addSimpleCondition(descr);
        if (cond) {
            query.fireConditionsChangedEvent(QueryChangeAction.Add, cond);
        }
    };
    AddRowRenderer.prototype.getMenu = function () {
        return this.menu;
    };
    return AddRowRenderer;
}(DropDownRenderer));
export { AddRowRenderer };
//# sourceMappingURL=addrow_renderer.js.map